<template>
  <div class="list-accordion" :id="uuid">
    <CommunityListAccordionItem
      v-for="(location, i) in locations"
      :key="i"
      :location="location"
      :communities="communitiesByLocation(location.slug)"
      @hook:mounted="itemMounted"
      @openPanel="resizeSlick()"
    />
  </div>

</template>
<script>
import CommunityListAccordionItem from '@/components/CommunityListAccordionItem';
import hasSlickSlider from '@/mixins/hasSlickSlider';
import { uuidv4 } from '@/helpers/ui';

export default {
  name: 'CommunityListAccordion',
  components: {
    CommunityListAccordionItem,
  },
  mixins: [hasSlickSlider],
  data() {
    return {
      sliderClass: '.list-slider',
    };
  },
  watch: {
    communities: {
      handler: function(newCommunities, oldCommunities) {
        if (newCommunities.length !== oldCommunities.length) {
          this.sliderUpdatePending = true;
        }
      },
    },
    isMapDisplayed: {
      handler: function() {
        this.resizeSlickSlider(this.uuid);
      },
    },
  },
  computed: {
    communities() {
      return this.$store.getters['communities/getCommunities'];
    },
    isMapDisplayed() {
      return this.$store.getters['ui/isMapDisplayed'];
    },
    locations() {
      return this.$store.getters['communities/getCommunityLocations'];
    },
    uuid() {
      return 'id-' + uuidv4();
    },
  },
  methods: {
    communitiesByLocation(location) {
      return this.$store.getters['communities/getCommunitiesByLocation'](location);
    },
    itemMounted() {
      // console.log('CommunityListAccordion itemMounted()');
      this.sliderUpdatePending = true;
    },
    resizeSlick() {
      this.resizeSlickSlider(this.uuid);
    },
  },
};
</script>
